import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReducer from './store.reducer';

export const ECOMMERCE_STORE_KEY = 'ECOMMERCE_STORE';
export const getStoreState =
  createFeatureSelector<fromReducer.IStoreState>(ECOMMERCE_STORE_KEY);

export const getStorePageState = createSelector(
  getStoreState,
  (state) => state
);
